import React, { useState, useCallback, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useOverlaySSE from './useOverlaySSE';
import api, { formatRupiah } from '../../lib/api';
import './overlay.css';

export default function OverlayTicker() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [items, setItems] = useState([]);

  const speed = parseInt(searchParams.get('speed') || '40');
  const accentColor = searchParams.get('accent') || '#FF6B35';
  const maxItems = 20;

  const fetchRecent = useCallback(async () => {
    try {
      const res = await api.get(`/overlay/recent-donations/${token}`, { params: { limit: maxItems } });
      setItems(res.data || []);
    } catch {}
  }, [token, maxItems]);

  useEffect(() => {
    fetchRecent();
  }, [fetchRecent]);

  const handleEvent = useCallback((event) => {
    if (event.type === 'donation') {
      setItems((prev) => {
        const next = [event, ...prev].slice(0, maxItems);
        return next;
      });
    }
  }, []);

  useOverlaySSE(token, handleEvent);

  if (items.length === 0) return <div className="overlay-container" style={{ '--ov-accent': accentColor }} />;

  // Calculate tickerDuration dynamically based on screen width + estimated track width
  const baseWidth = window.innerWidth || 1920;
  const estimatedTrackWidth = items.length * 300;
  const totalDistance = baseWidth + estimatedTrackWidth;
  const pxPerSec = speed * 3.75;
  const tickerDuration = Math.max(5, totalDistance / pxPerSec);

  return (
    <div className="overlay-container" style={{ '--ov-accent': accentColor }}>
      <div className="ticker-container">
        <div className="ticker-track" style={{ '--ticker-duration': `${tickerDuration}s` }}>
          {items.map((item, i) => (
            <div key={i} className="ticker-item">
              <span className="ticker-emoji">{item.unit_emoji || '☕'}</span>
              <span className="ticker-name">{item.supporter_name}</span>
              <span>mentraktir {item.qty}× {item.unit_name}</span>
              <span style={{ color: 'var(--ov-accent)', fontWeight: 800 }}>{formatRupiah(item.amount)}</span>
              <span className="ticker-sep">★</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
